import { ActivatedRoute } from '@angular/router';
import { ProjectSaleAttachmentInfo } from '../model/projectsaleattachment.model';
import { ProjectSaleActivityLogNoteInfo } from '../model/projectsaleactivitylognote.model';
import { ProjectSaleBudgetInfo } from '../model/ProjectSaleBudget.model';
import { ProjectSaleBudgetAttachedFileInfo } from '../model/ProjectSaleBudgetAttachedFile.model';
import { ProjectSaleCostInfo } from '../model/ProjectSaleCost.model';
import { ProjectSaleCostAttachedmentInfo } from '../model/ProjectSaleCostAttachedment.model';
import { flatMap } from 'rxjs/operators';
import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { EmpInfo } from '../model/emp.model';
import { SaleOrganizationInfo } from '../model/SaleOrganization.model';
import { GlobalService } from '../service/global.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormArray
} from '@angular/forms';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { LookupInfo } from '../model/lookup.model';
import { CompanyInfo } from '../model/company.model';
import { async } from '@angular/core/testing';
import { strict } from 'assert';
import { data } from 'jquery';
import { SaletrackingInfo } from '../model/saletracking.model';
import { ProjectGroupInfo } from '../model/ProjectGroupInfo';
import { TokenService } from '../service/token.service';

@Component({
  selector: 'app-information-list-lead-project',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './information-list-lead-project.component.html',
  styleUrls: ['./information-list-lead-project.component.css']
})
export class InformationListLeadProjectComponent implements OnInit {

  // Form Group Master
  InformationForm: FormGroup;
  form: FormGroup;
  public body: string;
  ProjectSaleListPromise: Promise<ProjectSaleInfo[]>
  ProjectSaleList: ProjectSaleInfo[]
  ProjectSaleListPromisereturn: Promise<ProjectSaleInfo[]>[]
  ProjectSaleLeadListPromise: Promise<ProjectSaleInfo[]>
  ProjectSaleLeadList: ProjectSaleInfo[]
  ProjectSaleLeadLsitPromisereturn: Promise<ProjectSaleInfo[]>[]
  CompanyList: CompanyInfo[]
  CategoryList: LookupInfo[]
  StatusList: LookupInfo[]
  ProjectSaleTypeList: LookupInfo[]
  ProjectSalePhaseList: LookupInfo[]
  ProjectSaleCustomerTypeList: LookupInfo[]
  empList: EmpInfo[]
  empListLoad: EmpInfo[]
  empListPromise: Promise<EmpInfo[]>
  empListPromiseReturn: Promise<EmpInfo[]>
  saleOrganizationList: SaleOrganizationInfo[]
  saleOrganizationPromise: Promise<SaleOrganizationInfo[]>
  saleOrganizationMaxList: SaleOrganizationInfo[]
  // array control
  itemsSupport: FormArray;
  flagduplicate: boolean;
  hidProjectSaleId: number

  // variable for loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  // project sale id from parameter
  _ParamProjectGroup: string
  _ParamProjectGroupName: string

  // Zone pagination variable
  public indexNo: number = 0
  public currentPageNumber: number
  public totalPages: number
  public environment: number
  public empcodeinit: string
  _EmpCode: string;
  hidebutton: Boolean;
  assignflag: boolean;
  viewflag: boolean;
  saleorglevelmax: number;
  saleorglevelemplogin: number;

  public currentPageNumberEmp: number
  public totalPagesEmp: number
  ProjectTotal: any
  EmpTotal: any
  isOnUpdate: boolean;
  isSubmitted: any;

  public totalActive: number
  public totalInActive: number
  public totalHold: number
  public totalClosed: number

  element: HTMLElement;
  public hidcouchk: number;
  public countall: number;
  baseurl: string;
  getreturn: Promise<string>;
  monthNameslist: any;
  yearlist: any[];
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService
    , private router: ActivatedRoute, private TokenService: TokenService) {
    this.baseurl = environment.base_api;
    //GlobalService.CheckPagingAccessRights();
  }

  ngOnInit() {

    this.currentPageNumber = 1;
    // set PageSize
    this.environment = environment.PageSizeSmall;
    this.empcodeinit = localStorage.getItem("EmpCode");
    this._EmpCode = localStorage.getItem("EmpCode");
    this.currentPageNumberEmp = 1;
    this.monthNameslist = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    this.yearlist = this.generateArrayOfYears();
    this.form = this.formBuilder.group({
      ProjectSaleCodeSearch: [null],
      ProjectSaleNameSearch: [null],
      ProjectSaleCompanyIdSearch: [null],
      ProjectSaleStatusSearch: [null],
      ProjectGroupMapping: [null],
      ProjectSaleCode: [null],
      ProjectSaleName: [null, Validators.required],
      ProjectSaleCompanyId: [null, Validators.required],
      ProjectSaleStatus: [null, Validators.required],
      ProjectSaleType: [null, Validators.required],
      ProjectSaleCategory: [null, Validators.required],
      ProjectSaleTool: [null],
      ProjectSalePhase: [null, Validators.required],
      ProjectSaleBudget: [null],
      ProjectSaleExpectedClosePeriodMonth: [null],
      ProjectSaleExpectedClosePerioddYear: [null],
      ProjectSaleContactDate: [null, Validators.required],
      ProjectSaleContactPerson: [null, Validators.required],
      ProjectSaleContactEmail: [null],
      ProjectSaleContactTel: [null, Validators.required],
      ProjectSaleCustomerType: [null, Validators.required],
      arraySupportTeam: this.formBuilder.array([this.createItemSupportTeamName()]),
      ProjectSaleRemark: [null],
      EmpCodeSearch: [null],
      EmpNameSearch: [null]
    });

    this.Clearinput();
    this.loadCompany().then((data) => {
      this.CompanyList = data;
    });

    this.loadLookup('PROJECTSALECATEGORY').then((data) => {
      this.CategoryList = data;
    });

    this.loadLookup('PROJECTSALESTATUS').then((data) => {
      this.StatusList = data;
    });

    this.loadLookup('PROJECTSALETYPE').then((data) => {
      this.ProjectSaleTypeList = data;
    });

    this.loadLookup('PROJECTSALEPHASE').then((data) => {
      this.ProjectSalePhaseList = data;
    });

    this.loadLookup('COMPANYCUSTOMERTPYE').then((data) => {
      this.ProjectSaleCustomerTypeList = data;
    });

    this.router.params.subscribe(params => {
      this._ParamProjectGroup = params['ProjectGroup'];
    });

    this.router.params.subscribe(params => {
      this._ParamProjectGroupName = params['ProjectGroupName'];
    });

    this.LoadSaleOrganizationLevel();
    this.LoadProjectSaleLead();
    this.LoadProjectSaleLeadAll();
    this.LoadListProjectGroup();
    this.LoadCountProjectGroup();

  }

  btnClick_SearchProjectSaleList() {
    this.currentPageNumber = 1; // away current page 1 when search
    this.indexNo = 0;
    this.LoadProjectSaleLead()
  }

  btnClick_SearchProjectSaleLeadList() {
    this.currentPageNumber = 1; // away current page 1 when search
    this.indexNo = 0;
    this.LoadProjectSaleLead()
  }
  Clearinput() {
    var d = new Date();
    var monthindex = d.getMonth() + 1;
    var year = d.getFullYear();

    this.form.patchValue({
      ProjectGroupMapping: null,
      ProjectSaleCode: null,
      ProjectSaleName: null,
      ProjectSaleCompanyId: null,
      ProjectSaleStatus: null,
      ProjectSaleType: null,
      ProjectSaleCategory: null,
      ProjectSaleTool: null,
      ProjectSalePhase: null,
      ProjectSaleBudget: null,
      ProjectSaleExpectedClosePeriodMonth: null,
      ProjectSaleExpectedClosePerioddYear: null,
      ProjectSaleContactDate: null,
      ProjectSaleContactPerson: null,
      ProjectSaleContactEmail: null,
      ProjectSaleContactTel: null,
      ProjectSaleCustomerType: null,
      ProjectSaleRemark: null,
    });

    // clear support team
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.clear();
    this.itemsSupport.push(this.createItemSupportTeamName());

  }

  createItemSupportTeamName(value = ''): FormGroup {
    return this.formBuilder.group({
      SupporTeamName: [value],
    },
      {
        // Used custom form validator 
        validator: []
      }
    );

  }

  addSupport(): void {
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.push(this.createItemSupportTeamName());
  }

  removeSupportItem(indexitem): void {
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.removeAt(indexitem);
  }

  ClearSearch() {
    this.form.patchValue({
      ProjectSaleCodeSearch: "",
      ProjectSaleNameSearch: "",
      ProjectSaleCompanyIdSearch: "",
      ProjectSaleStatusSearch: "",
    });
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.LoadProjectSaleLead();
  }

  LoadProjectSale(traget = null) {

    // check call function from change page or onloadfrist
    if (traget != null) {
      this.LoadProjectSaleUpdatePagination(traget);
    }

    this.LoadProjectSaleList();
    this.LoadProjectSaleCountList();
  }

  async LoadProjectSaleList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * this.environment;

      var objectjson = {};
      objectjson['ProjectGroupMapping'] = this._ParamProjectGroup;
      objectjson['rowFetch'] = this.environment;
      objectjson['rowOFFSet'] = offset;
      if (this.viewflag == true) {
      }
      else {
        objectjson['ProjectSaleCreateBy'] = this.checkUndefinedString(this.empcodeinit);
      }
      objectjson['ProjectSaleActiveFlag'] = "Y";
      objectjson['ProjectSaleFlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale", strjson, httpOptions)
        .toPromise().then((data) => {
          this.ProjectSaleList = data
        });
    }
  }

  async LoadProjectSaleCountList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['ProjectGroupMapping'] = this._ParamProjectGroup;
      objectjson['ProjectSaleActiveFlag'] = "Y";
      objectjson['ProjectSaleFlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale", strjson, httpOptions)
        .toPromise().then((data) => {
          this.hidcouchk = data.length;
          if (this.hidcouchk == 0) {
            this.currentPageNumber = 0;
            this.totalPages = 0;
          } else {
            this.totalPages = Math.ceil(this.hidcouchk / this.environment);
          }
        });
    }
  }

  async LoadProjectSaleAll() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['ProjectSaleActiveFlag'] = "Y";
      objectjson['ProjectSaleFlagDelete'] = "N";

      if (this.viewflag == true) {

      }
      else {
        objectjson['ProjectSaleCreateBy'] = this.checkUndefinedString(this.empcodeinit);
      }

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale", strjson, httpOptions)
        .toPromise().then((data) => {
          this.countall = data.length;

          this.totalActive = data.filter(function (el) {
            return el.ProjectSaleStatusDisplay == 'Active'
          }).length;

          this.totalInActive = data.filter(function (el) {
            return el.ProjectSaleStatusDisplay == 'Inactive'
          }).length;

          this.totalHold = data.filter(function (el) {
            return el.ProjectSaleStatusDisplay == 'Hold'
          }).length;

          this.totalClosed = data.filter(function (el) {
            return el.ProjectSaleStatusDisplay == 'Closed'
          }).length;

        })
    }
  }

  LoadProjectSaleLead(traget = null) {

    // check call function from change page or onloadfrist
    if (traget != null) {
      this.LoadProjectSaleLeadUpdatePagination(traget);
    }

    this.LoadProjectSaleLeadList();
    this.LoadProjectSaleCountLeadList();
  }

  async LoadProjectSaleLeadList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * this.environment;

      var objectjson = {};
      objectjson['ProjectSaleCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCodeSearch'].value);
      objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleNameSearch'].value);
      objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value)) : 0;
      objectjson['ProjectSaleStatus'] = this.checkUndefinedString(this.form.controls['ProjectSaleStatusSearch'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleStatusSearch'].value)) : 0;
      objectjson['rowFetch'] = this.environment;
      objectjson['rowOFFSet'] = offset;
      objectjson['ProjectSaleCurrentEmpCode'] = this.checkUndefinedString(this.empcodeinit);
      objectjson['ProjectSaleActiveFlag'] = "Y";
      objectjson['ProjectSaleFlagDelete'] = "N";


      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectLeadGroup", strjson, httpOptions)
        .toPromise().then((data) => {

          this.ProjectSaleLeadList = data

        });
    }
  }

  async LoadProjectSaleCountLeadList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };


      var objectjson = {};
      objectjson['ProjectSaleCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCodeSearch'].value);
      objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleNameSearch'].value);
      objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value)) : 0;
      objectjson['ProjectSaleStatus'] = this.checkUndefinedString(this.form.controls['ProjectSaleStatusSearch'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleStatusSearch'].value)) : 0;

      if (this.viewflag == true) {

      }
      else {
        objectjson['ProjectSaleCurrentEmpCode'] = this.checkUndefinedString(this.empcodeinit);
      }
      objectjson['ProjectSaleActiveFlag'] = "Y";
      objectjson['ProjectSaleFlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectLeadGroup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.hidcouchk = data.length;
          if (this.hidcouchk == 0) {
            this.currentPageNumber = 0;
            this.totalPages = 0;
          } else {
            this.totalPages = Math.ceil(this.hidcouchk / this.environment);
          }

        });
    }
  }

  async LoadProjectSaleLeadAll() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['ProjectSaleActiveFlag'] = "Y";
      objectjson['ProjectSaleFlagDelete'] = "N";

      if (this.viewflag == true) {

      }
      else {
        objectjson['ProjectSaleCreateBy'] = this.checkUndefinedString(this.empcodeinit);
      }

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectLeadGroup", strjson, httpOptions)
        .toPromise().then((data) => {
          this.countall = data.length;

          this.totalActive = data.filter(function (el) {
            return el.ProjectSaleStatusDisplay == 'Active'
          }).length;

          this.totalInActive = data.filter(function (el) {
            return el.ProjectSaleStatusDisplay == 'Inactive'
          }).length;

          this.totalHold = data.filter(function (el) {
            return el.ProjectSaleStatusDisplay == 'Hold'
          }).length;

          this.totalClosed = data.filter(function (el) {
            return el.ProjectSaleStatusDisplay == 'Closed'
          }).length;
        })
    }
  }

  async btnClick_submitInsertProjectSale() {
    if (this.form.valid) {
      console.log('form submitted');
      this.OnCreating('y');
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        // gen array support control to json
        this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
        var jsonsupportteam = this.ConvertFormArrayToJson(this.itemsSupport);
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectGroupMapping'] = this.checkUndefinedString(this.form.controls['ProjectGroupMapping'].value);
        objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleName'].value);
        objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyId'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyId'].value)) : 0;
        objectjson['ProjectSaleCompanyAbbreviation'] = this.checkUndefinedString($('#ProjectSaleCompanyId option:selected').attr('companyabbreviation'));
        objectjson['ProjectSaleStatus'] = this.checkUndefinedString(this.form.controls['ProjectSaleStatus'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleStatus'].value)) : 0;
        objectjson['ProjectSaleType'] = this.checkUndefinedString(this.form.controls['ProjectSaleType'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleType'].value)) : 0;
        objectjson['ProjectSaleTypeDisplay'] = this.checkUndefinedString($('#ProjectSaleType option:selected').attr('projectsaletypedisplay'));
        objectjson['ProjectSaleCategoryCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCategory'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleCategory'].value) : null;
        objectjson['ProjectSaleTool'] = this.checkUndefinedString(this.form.controls['ProjectSaleTool'].value);
        objectjson['ProjectSalePhase'] = this.checkUndefinedString(this.form.controls['ProjectSalePhase'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSalePhase'].value)) : 0;
        objectjson['ProjectSalePhaseDisplay'] = this.checkUndefinedString($('#ProjectSalePhase option:selected').attr('projectsalephasedisplay'));
        objectjson['ProjectSaleBudget'] = this.checkUndefinedString(this.form.controls['ProjectSaleBudget'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleBudget'].value)) : 0;
        objectjson['ProjectSaleClosedPeriodMonth'] = this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePeriodMonth'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePeriodMonth'].value) : null;
        objectjson['ProjectSaleClosedPeriodYear'] = this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePerioddYear'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePerioddYear'].value) : null;
        objectjson['ProjectSaleContactDate'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactDate'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleContactDate'].value) : null;
        objectjson['ProjectSaleContactPerson'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactPerson'].value);
        objectjson['ProjectSaleContactEmail'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactEmail'].value)
        objectjson['ProjectSaleContactTel'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactTel'].value)
        objectjson['ProjectSaleCustomerType'] = this.checkUndefinedString(this.form.controls['ProjectSaleCustomerType'].value)
        objectjson['ProjectSaleSupportTeam'] = this.checkUndefinedString(jsonsupportteam);
        objectjson['ProjectSaleRemark'] = this.checkUndefinedString(this.form.controls['ProjectSaleRemark'].value);
        objectjson['ProjectSaleCreateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objectjson['ProjectSaleRequestTypeCode'] = '1';
        objectjson['ProjectSaleFlagDelete'] = "N";

        let strjson = JSON.stringify(objectjson);

        this.isSubmitted = this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/InsertProjectSale", strjson, httpOptions)
          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
            this.OnCreating('n');
          },
            () => {
              console.log("Insert = " + this.isSubmitted)
              this.OnCreating('n');
              //$('#ModalCreateComplate').modal();
              this.currentPageNumber = 1;
              this.indexNo = 0;
              this.LoadProjectSale();
              this.LoadProjectSaleAll();
            }
          );
      }
    } else {
      this.GlobalService.validateAllFormFields(this.form);
    }
  }

  btnClick_onUpdateProjectSale(id) {
    $('#ModalProjectSale').modal('hide');
    this.Clearinput();
    this.isOnUpdate = true

    let index = this.ProjectSaleList.findIndex(x => x.ProjectSaleId == id);

    // get json object from field SupportTeam
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.clear();
    var objectSupportTeamFromJson = [];
    if (this.ProjectSaleList[index].ProjectSaleSupportTeam != null && this.ProjectSaleList[index].ProjectSaleSupportTeam != '') {
      objectSupportTeamFromJson = JSON.parse(this.ProjectSaleList[index].ProjectSaleSupportTeam);
    }

    for (let i = 0; i < objectSupportTeamFromJson.length; i++) {
      this.itemsSupport.push(this.createItemSupportTeamName(objectSupportTeamFromJson[i].SupporTeamName));
    }

    var d = new Date();
    var monthindex = d.getMonth() + 1;
    var yearcurrent = d.getFullYear();

    this.form.patchValue({
      ProjectGroupMapping: this.ProjectSaleList[index].ProjectGroupMapping != null ? this.ProjectSaleList[index].ProjectGroupMapping : null,
      ProjectSaleCode: this.ProjectSaleList[index].ProjectSaleCode != null ? this.ProjectSaleList[index].ProjectSaleCode : null,
      ProjectSaleName: this.ProjectSaleList[index].ProjectSaleName != null ? this.ProjectSaleList[index].ProjectSaleName : null,
      ProjectSaleCompanyId: this.ProjectSaleList[index].ProjectSaleCompanyId != null ? this.ProjectSaleList[index].ProjectSaleCompanyId : null,
      ProjectSaleStatus: this.ProjectSaleList[index].ProjectSaleStatus != null ? this.ProjectSaleList[index].ProjectSaleStatus : null,
      ProjectSaleType: this.ProjectSaleList[index].ProjectSaleType != null ? this.ProjectSaleList[index].ProjectSaleType : null,
      ProjectSaleCategory: this.ProjectSaleList[index].ProjectSaleCategoryCode != null ? this.ProjectSaleList[index].ProjectSaleCategoryCode : null,
      ProjectSaleTool: this.ProjectSaleList[index].ProjectSaleTool != null ? this.ProjectSaleList[index].ProjectSaleTool : null,
      ProjectSalePhase: this.ProjectSaleList[index].ProjectSalePhase != null ? this.ProjectSaleList[index].ProjectSalePhase : null,
      ProjectSaleBudget: this.ProjectSaleList[index].ProjectSaleBudget != null ? this.ProjectSaleList[index].ProjectSaleBudget : null,
      ProjectSaleExpectedClosePeriodMonth: this.ProjectSaleList[index].ProjectSaleClosedPeriodMonth != "" ? parseInt(this.ProjectSaleList[index].ProjectSaleClosedPeriodMonth) : monthindex,
      ProjectSaleExpectedClosePerioddYear: this.ProjectSaleList[index].ProjectSaleClosedPeriodYear != "" ? parseInt(this.ProjectSaleList[index].ProjectSaleClosedPeriodYear) : yearcurrent,
      ProjectSaleContactDate: this.ProjectSaleList[index].ProjectSaleContactDate != null && this.ProjectSaleList[index].ProjectSaleContactDate != "" ? this.formatDate(this.ProjectSaleList[index].ProjectSaleContactDate) : null,
      ProjectSaleContactPerson: this.ProjectSaleList[index].ProjectSaleContactPerson != null ? this.ProjectSaleList[index].ProjectSaleContactPerson : null,
      ProjectSaleContactEmail: this.ProjectSaleList[index].ProjectSaleContactEmail != null ? this.ProjectSaleList[index].ProjectSaleContactEmail : null,
      ProjectSaleContactTel: this.ProjectSaleList[index].ProjectSaleContactTel != null ? this.ProjectSaleList[index].ProjectSaleContactTel : null,
      ProjectSaleCustomerType: this.ProjectSaleList[index].ProjectSaleCustomerType != null ? parseInt(this.ProjectSaleList[index].ProjectSaleCustomerType) : null,
      ProjectSaleRemark: this.ProjectSaleList[index].ProjectSaleRemark != null ? this.ProjectSaleList[index].ProjectSaleRemark : null,
    });

    this.hidProjectSaleId = this.ProjectSaleList[index].ProjectSaleId

    $('#ModalProjectSale').modal();

  }

  async btnClick_submitUpdateProjectSale(id) {
    if (this.form.valid) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.OnUpdating('y');
        id = this.hidProjectSaleId
        // gen array support control to json
        this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
        var jsonsupportteam = this.ConvertFormArrayToJson(this.itemsSupport);

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = {};
        objectjson['ProjectSaleId'] = id;
        objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleName'].value);
        objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyId'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyId'].value)) : 0;
        objectjson['ProjectSaleCompanyAbbreviation'] = this.checkUndefinedString($('#ProjectSaleCompanyId option:selected').attr('companyabbreviation'));
        objectjson['ProjectSaleStatus'] = this.checkUndefinedString(this.form.controls['ProjectSaleStatus'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleStatus'].value)) : 0;
        objectjson['ProjectSaleType'] = this.checkUndefinedString(this.form.controls['ProjectSaleType'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleType'].value)) : 0;
        objectjson['ProjectSaleTypeDisplay'] = this.checkUndefinedString($('#ProjectSaleType option:selected').attr('projectsaletypedisplay'));
        objectjson['ProjectSaleCategoryCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCategory'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleCategory'].value) : null;
        objectjson['ProjectSaleTool'] = this.checkUndefinedString(this.form.controls['ProjectSaleTool'].value);
        objectjson['ProjectSalePhase'] = this.checkUndefinedString(this.form.controls['ProjectSalePhase'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSalePhase'].value)) : 0;
        objectjson['ProjectSalePhaseDisplay'] = this.checkUndefinedString($('#ProjectSalePhase option:selected').attr('projectsalephasedisplay'));
        objectjson['ProjectSaleBudget'] = this.checkUndefinedString(this.form.controls['ProjectSaleBudget'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleBudget'].value)) : 0;
        objectjson['ProjectSaleClosedPeriodMonth'] = this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePeriodMonth'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePeriodMonth'].value) : null;
        objectjson['ProjectSaleClosedPeriodYear'] = this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePerioddYear'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleExpectedClosePerioddYear'].value) : null;
        objectjson['ProjectSaleContactDate'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactDate'].value) != "" ? this.checkUndefinedString(this.form.controls['ProjectSaleContactDate'].value) : null;
        objectjson['ProjectSaleContactPerson'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactPerson'].value);
        objectjson['ProjectSaleContactEmail'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactEmail'].value)
        objectjson['ProjectSaleContactTel'] = this.checkUndefinedString(this.form.controls['ProjectSaleContactTel'].value)
        objectjson['ProjectSaleCustomerType'] = this.checkUndefinedString(this.form.controls['ProjectSaleCustomerType'].value)
        objectjson['ProjectSaleSupportTeam'] = this.checkUndefinedString(jsonsupportteam);
        objectjson['ProjectSaleRemark'] = this.checkUndefinedString(this.form.controls['ProjectSaleRemark'].value);
        objectjson['ProjectSaleUpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

        let strjson = JSON.stringify(objectjson);
        this.isSubmitted = this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateProjectSale", strjson, httpOptions)
          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail");
            this.OnUpdating('n');
          },
            () => {
              console.log("Update = " + this.isSubmitted);
              this.OnUpdating('n');
              $('#ModalUpdateComplate').modal();
              this.LoadProjectSale();
              this.LoadProjectSaleAll();
            }
          );
      }
    } else {
      this.GlobalService.validateAllFormFields(this.form);
    }
  }
  btnClick_updateProjectSaleLead(id): Observable<ProjectSaleInfo[]> {

    var auth_token = this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectSaleId'] = id;
      objectjson['ProjectGroupMapping'] = this._ParamProjectGroup;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateGroupProjectSale", strjsonCusInfo, httpOptions);
    }
  }

  chkallclicklead(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxProjectSaleLead"]').prop('checked', check);

  }

  btnClick_updateProjectSaleLeaditem(id) {

    if (confirm("Are you sure you want to update this Project ?")) {
      this.btnClick_updateProjectSaleLead(parseInt(id)).toPromise()
        .then(
          data => {
            console.log('หลังรับค่า');
            $('#ModalUpdateComplate').modal('show');
            this.LoadProjectSale();
            this.LoadProjectSaleAll();
          }
        );
    }
  }

  //Delete แบบ list
  btnClick_onUpdateProjectSaleLeadList() {

    if (confirm("Are you sure you want to update this Project?")) {

      var checkkedProjectSaleLead = $('[name="checkboxProjectSaleLead"]:checked');

      let num = checkkedProjectSaleLead.length;
      let observableBatch = [];
      for (var i = 0; i < num; i++) {

        var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSaleLead[i];
        observableBatch.push(this.btnClick_updateProjectSaleLead(parseInt(ProjectSalecurrent.value)).toPromise().then(val => {
        }));
      }

      Promise.all(observableBatch).then(val => {

        this.SendListIdToUpdate(observableBatch);

      });
    }
  }
  async SendListIdToUpdate(observableBatch: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjsonCusInfo = JSON.stringify(observableBatch);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateGroupProjectSale", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          data => {
            console.log('สำเร็จ');
            $('#ModalUpdateComplate').modal('show');
            this.currentPageNumber = 1;
            this.LoadProjectSale();
            this.LoadProjectSaleAll();
          }
        );
    }
  }

  btnClick_deleteProjectSale(id): Observable<ProjectSaleInfo[]> {
    var auth_token = this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectSaleId'] = id;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/DeleteProjectGroupMapping", strjsonCusInfo, httpOptions);
    }
  }

  chkallclick(traget) {
    var check = $(traget.currentTarget).is(":checked");

    $('[name="checkboxProjectSale"]').prop('checked', check);

  }

  btnClick_deleteProjectSaleitem(id) {

    if (confirm("Are you sure you want to delete this Project ?")) {
      this.btnClick_deleteProjectSale(parseInt(id)).toPromise()
        .then(
          data => {
            console.log('หลังรับค่า');
            $('#ModalDeleteComplate').modal('show');
            this.LoadProjectSale();
            this.LoadProjectSaleAll();
          }
        );
    }
  }

  //Delete แบบ list
  btnClick_onDeleteProjectSaleList() {

    if (confirm("Are you sure you want to delete this Project?")) {

      var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');

      let num = checkkedProjectSale.length;
      let observableBatch = [];
      for (var i = 0; i < num; i++) {

        var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];
        observableBatch.push(this.btnClick_deleteProjectSale(parseInt(ProjectSalecurrent.value)).toPromise().then(val => {
        }));
      }

      Promise.all(observableBatch).then(val => {

        this.SendListIdToDelete(observableBatch);

      });
    }
  }
  async SendListIdToDelete(observableBatch: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjsonCusInfo = JSON.stringify(observableBatch);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/DeleteListProjectGroupMapping", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          data => {
            console.log('สำเร็จ');
            $('#ModalDeleteComplate').modal('show');
            this.currentPageNumber = 1;
            this.LoadProjectSale();
            this.LoadProjectSaleAll();
          }
        );
    }
  }

  btnClick_updateProjectMapping(id): Observable<ProjectSaleInfo[]> {
    var auth_token = this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectSaleId'] = id;
      objectjson['ProjectGroupMapping'] = this._ParamProjectGroup;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateGroupProjectSale", strjsonCusInfo, httpOptions);
    }
  }

  btnClick_updateProjectMappingitem(id) {

    if (confirm("Are you sure you want to delete this Project ?")) {
      this.btnClick_updateProjectSaleLead(parseInt(id)).toPromise()
        .then(
          data => {
            console.log('หลังรับค่า');
            $('#ModalDeleteComplate').modal('show');
            this.LoadProjectSale();
            this.LoadProjectSaleAll();
          }
        );
    }
  }

  //Delete แบบ list
  btnClick_onUpdateProjectMappingList() {

    if (confirm("Are you sure you want to delete this Project?")) {

      var checkkedProjectSaleLead = $('[name="checkboxProjectSaleLead"]:checked');

      let num = checkkedProjectSaleLead.length;
      let observableBatch = [];
      for (var i = 0; i < num; i++) {

        var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSaleLead[i];
        observableBatch.push(this.btnClick_updateProjectSaleLead(parseInt(ProjectSalecurrent.value)).toPromise().then(val => {
        }));
      }

      Promise.all(observableBatch).then(val => {

        this.SendListIdToUpdateMapping(observableBatch);

      });
    }
  }
  async SendListIdToUpdateMapping(observableBatch: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjsonCusInfo = JSON.stringify(observableBatch);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateGroupProjectSale", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          data => {
            console.log('สำเร็จ');
            $('#ModalDeleteComplate').modal('show');
            this.currentPageNumber = 1;
            this.LoadProjectSale();
            this.LoadProjectSaleAll();

          }
        );
    }
  }

  btnClick_deleteProjectMapping(id): Observable<ProjectSaleInfo[]> {
    var auth_token = this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectSaleId'] = id;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/DeleteProjectGroupMapping", strjsonCusInfo, httpOptions);
    }
  }

  btnClick_deleteProjectMappingitem(id) {

    if (confirm("Are you sure you want to delete this Project ?")) {
      this.btnClick_deleteProjectSale(parseInt(id)).toPromise()
        .then(
          data => {
            console.log('หลังรับค่า');
            $('#ModalDeleteComplate').modal('show');
            this.LoadProjectSale();
            this.LoadProjectSaleAll();
          }
        );
    }
  }

  //Delete แบบ list
  btnClick_onDeleteProjectMappingList() {

    if (confirm("Are you sure you want to delete this Project?")) {

      var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');

      let num = checkkedProjectSale.length;
      let observableBatch = [];
      for (var i = 0; i < num; i++) {

        var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];
        observableBatch.push(this.btnClick_deleteProjectSale(parseInt(ProjectSalecurrent.value)).toPromise().then(val => {
        }));
      }

      Promise.all(observableBatch).then(val => {

        this.SendListIdToDelete(observableBatch);

      });
    }
  }

  btnClick_onCreateProjectSale() {
    this.form.reset();
    $('#ModalProjectSale').modal('show');
    this.Clearinput();
    this.isOnUpdate = false
  }

  isFieldValid(field: string) {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  async loadCompany() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/GetCompany", strjson, httpOptions)
        .toPromise()
    }
  }

  async loadLookup(lookuptype: string) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = this.checkUndefinedString(lookuptype);

      let strjson = JSON.stringify(objectjson);

      return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise()
    }
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput
  }

  OnCreating(flag) {
    if (flag == 'y') {
      $("#loadingcreate").show();
      $("#btnsubmitProjectSale").hide();
      $("#txtProjectSaleCode").prop('disabled', true);
      $("#txtProjectSaleName").prop('disabled', true);
      $("#txtProjectSaleContactName").prop('disabled', true);
      $("#txtProjectSaleLink").prop('disabled', true);
      $("#txtProjectSaleIndustry").prop('disabled', true);
      $("#txtProjectSaleCustomerType").prop('disabled', true);
      $("#txtProjectSaleDescription").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingcreate").hide();
      $("#btnsubmitProjectSale").show();
      $("#txtProjectSaleCode").removeAttr('disabled');
      $("#txtProjectSaleName").removeAttr('disabled');
      $("#txtProjectSaleContactName").removeAttr('disabled');
      $("#txtProjectSaleLink").removeAttr('disabled');
      $("#txtProjectSaleIndustry").removeAttr('disabled');
      $("#txtProjectSaleCustomerType").removeAttr('disabled');
      $("#txtProjectSaleDescription").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalProjectSale').modal('hide');
    }
  }

  OnUpdating(flag) {
    if (flag == 'y') {
      $("#loadingupdate").show();
      $("#btnsubmitProjectSale").hide();
      $("#txtProjectSaleCode").prop('disabled', true);
      $("#txtProjectSaleName").prop('disabled', true);
      $("#txtProjectSaleContactName").prop('disabled', true);
      $("#txtProjectSaleLink").prop('disabled', true);
      $("#txtProjectSaleIndustry").prop('disabled', true);
      $("#txtProjectSaleCustomerType").prop('disabled', true);
      $("#txtProjectSaleDescription").prop('disabled', true);
      $('#btncloseicon').prop('disabled', true);
      $('#btnclose').prop('disabled', true);
    } else if (flag == 'n') {
      $("#loadingupdate").hide();
      $("#btnsubmitProjectSale").show();
      $("#txtProjectSaleCode").removeAttr('disabled');
      $("#txtProjectSaleName").removeAttr('disabled');
      $("#txtProjectSaleContactName").removeAttr('disabled');
      $("#txtProjectSaleLink").removeAttr('disabled');
      $("#txtProjectSaleIndustry").removeAttr('disabled');
      $("#txtProjectSaleCustomerType").removeAttr('disabled');
      $("#txtProjectSaleDescription").removeAttr('disabled');
      $('#btncloseicon').removeAttr('disabled');
      $('#btnclose').removeAttr('disabled');
      $('#ModalProjectSale').modal('hide');
    }
  }

  CheckduplicateProjectSaleCode() {
    if (this.isOnUpdate == true) {
      return false;
    }

    var ProjectSaleCode = this.form.controls['ProjectSaleCode'].value;
    let index = this.ProjectSaleList.findIndex(x => x.ProjectSaleCode == ProjectSaleCode);
    var flagreturn = false;
    if (index != -1) {
      flagreturn = true;
    }
    this.flagduplicate = flagreturn;
    return flagreturn;
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  ConvertDate(DateValue) {
    if (DateValue) {

      var date = new Date(DateValue);
      var dayname = date.getDay();
      var day = date.getDate();
      var daystr = '';

      if (day < 10) {
        daystr = '0' + day
      } else {
        daystr = day.toString();
      }

      var monthIndex = date.getMonth() + 1;
      var monthstr = '';

      if (monthIndex < 10) {
        monthstr = '0' + monthIndex
      } else {
        monthstr = monthIndex.toString();
      }

      var year = date.getFullYear();
      var Hours = date.getHours();
      var Minutes = date.getMinutes();
      var Datenow = '';

      Datenow = monthstr + "/" + daystr + "/" + year;
    }
    else {

      Datenow = null;
    }

    return Datenow;

  }

  displayhyperlink(projectcode: string, projectsaleid: number) {
    var body = ""
    body += " <a href=\"/saletracking-management?ProjectSaleID=" + projectsaleid + "\">" + projectcode + "</a>"

    return body;
  }

  generateArrayOfYears() {
    var max = new Date().getFullYear() + 5
    var min = max - 5
    var years = []

    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years
  }

  btnonclick_loadcompany() {
    this.loadCompany().then((data) => {
      this.CompanyList = data;
    });
  }

  btnonclick_loadCategory() {
    this.loadLookup('PROJECTSALECATEGORY').then((data) => {
      this.CategoryList = data;
    });
  }

  btnClick_onAssignEmpClick() {
    $('#ModalEmpAssign').modal('show');
  }

  ClearSearchEmp() {
    this.form.patchValue({
      EmpCodeSearch: "",
      EmpNameSearch: "",
    });
  }

  LoadEmp() {
    this.LoadEmpList()
      .then(
        data => {
          this.empList = data;
        }
      ).then(() => {
        this.CountEmpList();
      })
  }

  async LoadEmpList(): Promise<EmpInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['EmpCode'] = this.checkUndefinedString(this.form.controls['EmpCodeSearch'].value);
      objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);
      objectjson['FlagDelete'] = 'N';
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      this.empListPromise = this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
        .toPromise()

      return this.empListPromise;
    }
  }

  async CountEmpList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['EmpCode'] = this.checkUndefinedString(this.form.controls['EmpCodeSearch'].value);
      objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);
      objectjson['FlagDelete'] = 'N';

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetCountEmployeeCriteria", strjson, httpOptions)
        .toPromise().then(data => {
          this.EmpTotal = data;
          if(this.EmpTotal == 0) this.currentPageNumberEmp = 0;
        })
        .then(() => {
          this.totalPagesEmp = Math.ceil(this.EmpTotal / environment.PageSize);
        });
    }
  }

  btnClickshowEmp() {
    this.LoadEmpforAssign();

  }

  btnClick_previous() {
    if (this.currentPageNumberEmp == 1) {

    } else {
      this.currentPageNumberEmp -= 1
      this.LoadEmp();
    }
  }

  btnClick_next() {
    if (this.currentPageNumberEmp == this.totalPagesEmp) {

    } else {
      this.currentPageNumberEmp += 1
      this.LoadEmp();
    }
  }

  btnClick_first() {
    if (this.currentPageNumberEmp == 1) {

    } else {
      this.currentPageNumberEmp = 1
      this.LoadEmp();
    }

  }

  btnClick_last() {
    if (this.currentPageNumberEmp == this.totalPagesEmp) {

    } else {
      this.currentPageNumberEmp = this.totalPagesEmp
      this.LoadEmp();
    }
  }

  LoadSaleOrganizationLevel() {

    this.LoadSaleOrganizationLevelList().then(data => {
      this.saleOrganizationList = data;

      if (this.saleOrganizationList.length > 0) {
        if (this.saleOrganizationList[0].AssignFlag == 'Y') {
          this.hidebutton = false;
          this.assignflag = false;
        }
        else {
          this.hidebutton = true;
          this.assignflag = true;
        }
      }
      else {
        this.hidebutton = true;
        this.assignflag = true;
      }

      if (this.saleOrganizationList.length > 0) {
        if (this.saleOrganizationList[0].ViewFlag == 'Y') {
          this.viewflag = true;
        }
        else {
          this.viewflag = false;
        }
      }
      else {
        this.viewflag = false;
      }

      if (this.saleOrganizationList.length > 0) {
        this.saleorglevelemplogin = this.saleOrganizationList[0].Levels
      }
      else {
        this.saleorglevelemplogin = 1;
      }

      this.LoadProjectSale();
      this.LoadProjectSaleAll();
    }).then(() => {
      this.LoadSaleOrganizationLevelmax();

    });
  }

  async LoadSaleOrganizationLevelList(): Promise<SaleOrganizationInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

      var objectjson = {};
      objectjson['EmpCode'] = this.checkUndefinedString(this.empcodeinit);

      let strjson = JSON.stringify(objectjson);

      this.saleOrganizationPromise = this.httpClient.post<SaleOrganizationInfo[]>(this.baseurl + "SaleOrganization/GetSaleOrganization", strjson, httpOptions)
        .toPromise()

      return this.saleOrganizationPromise;
    }
  }

  async LoadSaleOrganizationLevelmax() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

      var objectjson = {};

      let strjson = JSON.stringify(objectjson);

      this.httpClient.post<SaleOrganizationInfo[]>(this.baseurl + "SaleOrganization/GetSaleOrganization", strjson, httpOptions)
        .toPromise().then(
          data => {
            this.saleOrganizationMaxList = data;
            this.saleOrganizationMaxList = this.saleOrganizationMaxList.sort((a, b) => a.Levels - b.Levels);

            if (this.saleOrganizationMaxList.length > 0) {
              this.saleorglevelmax = this.saleOrganizationMaxList[this.saleOrganizationMaxList.length - 1].Levels;

            }
            else {
              this.saleorglevelmax = 1;
            }

            this.LoadEmpforAssign();
          });
    }
  }

  async LoadEmpforAssign() {

    if (this.saleorglevelemplogin > 1 && this.saleorglevelmax > 1) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

        var objectjson = {};
        objectjson['saleorglevel'] = this.saleorglevelemplogin;
        objectjson['saleorglevelmax'] = this.saleorglevelmax;
        objectjson['rowFetch'] = environment.PageSize;
        objectjson['rowOFFSet'] = offset;
        objectjson['EmpCode'] = this.checkUndefinedString(this.form.controls['EmpCodeSearch'].value);
        objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);

        let strjson = JSON.stringify(objectjson);

        this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmpforAssignProjectSale", strjson, httpOptions)
          .toPromise().then(
            data => {
              this.empListLoad = data;
              console.log("JSON result empassign : " + JSON.stringify(this.empListLoad));
            }).then(() => {
              this.CountLoadEmpforAssign();
            });
      }
    }
    else {
      this.empListLoad = [];
      console.log("JSON result empassign : " + JSON.stringify(this.empListLoad));
    }
  }

  async CountLoadEmpforAssign() {
    if (this.saleorglevelemplogin > 1 && this.saleorglevelmax > 1) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        let offset = (this.currentPageNumberEmp - 1) * environment.PageSize;

        var objectjson = {};
        objectjson['saleorglevel'] = this.saleorglevelemplogin;
        objectjson['saleorglevelmax'] = this.saleorglevelmax;
        objectjson['EmpCode'] = this.checkUndefinedString(this.form.controls['EmpCodeSearch'].value);
        objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);

        let strjson = JSON.stringify(objectjson);

        this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetCountEmpforAssignProjectSale", strjson, httpOptions)
          .toPromise().then(data => {
            this.EmpTotal = data;
            if(this.EmpTotal == 0) this.currentPageNumberEmp = 0;
          })
          .then(() => {
            this.totalPagesEmp = Math.ceil(this.EmpTotal / environment.PageSize);
          });
      }
    }
    else {
      this.EmpTotal = 0;
    }

  }

  assignclicked(item) {

    if (confirm("Are you sure you want to assign sale employee?")) {

      $('#ModalEmpAssign').modal('hide');
      let EmpCode = this.empListLoad.findIndex(x => x.Id == item);

      var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');

      let num = checkkedProjectSale.length;
      let observableBatch = [];

      for (var i = 0; i < num; i++) {

        var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];
        observableBatch.push(this.btnClick_assignProjectSale(parseInt(ProjectSalecurrent.value), item, this._EmpCode).toPromise().then(val => {
        }));
      }

      Promise.all(observableBatch).then(val => {
        console.log('สำเร็จ');
        $('#ModalEmpAssignComplate').modal('show');
        this.LoadProjectSale();
        this.LoadEmpforAssign();
      });
    }
  }

  btnClick_assignProjectSale(id, AssignTo, AssignBy): Observable<ProjectSaleInfo[]> {
    var auth_token = this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectSaleId'] = id;
      objectjson['ProjectSaleAssignTo'] = AssignTo;
      objectjson['ProjectSaleAssignBy'] = AssignBy;
      objectjson['ProjectSaleUpdateBy'] = AssignBy;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/AssignEmpProjectSale", strjsonCusInfo, httpOptions);
    }
  }

  ConvertFormArrayToJson(objectFormArray: FormArray): string {
    var objectarray = [];
    $.each(objectFormArray.controls, function (index, value) {
      objectarray.push(value.value);
    });

    return JSON.stringify(objectarray);

  }

  // Function Update variable abount pagination
  LoadProjectSaleUpdatePagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;

  }
  // Function Update variable abount pagination
  LoadProjectSaleLeadUpdatePagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;

  }

  //Lead group
  //function Update Group projectsale
  //1. Get list project group to modal
  //2. Send list projs id to save 
  //Variables
  listProjGroup: ProjectGroupInfo[] = [];
  totalProjectGroup: number;
  totalPage_ProjectGroup: number;
  currentPageNumber_ProjectGroup: number;

  async LoadListProjectGroup() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<ProjectGroupInfo[]>(this.baseurl + "Master/GetProjectGroup",
          strjson, httpOptions)
        .subscribe(data => {
          this.listProjGroup = data;
        });
    }
  }

  async LoadCountProjectGroup() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      let strjson = JSON.stringify(objectjson);

      this.httpClient
        .post<number>(this.baseurl + "Master/GetCountProjectGroup",
          strjson, httpOptions)
        .subscribe(data => {

          this.currentPageNumber_ProjectGroup = 1;
          this.totalProjectGroup = data;//จำนวน data ทั้งหมด
          this.totalPage_ProjectGroup = Math.ceil(this.totalProjectGroup / environment.PageSizeSmall);//จำนวนที่แบ่ง page ได้
        });
    }
  }

  OnLoadProjGroupFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber_ProjectGroup = traget.currentPageNumber;
      this.totalPage_ProjectGroup = traget.totalPages;
    }

    this.LoadListProjectGroup();
  }
  OnBtnOpenProjectGroupModalClick() {
    $('#ModalProjectGroup').modal();
  }
  OnBtnAssignGroupProjectSaleList(groupcode) {

    if (confirm("Are you sure you want to Update group this Project?")) {

      var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');
      var Groupproject = groupcode;
      let num = checkkedProjectSale.length;
      let observableBatch = [];
      for (var i = 0; i < num; i++) {

        var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];

        var projcode = $(ProjectSalecurrent).data('projcode');
        observableBatch.push(this.btnClick_UpdateGroupProjectSale(parseInt(ProjectSalecurrent.value), projcode, Groupproject).toPromise().then(val => {
        }));
      }

      Promise.all(observableBatch).then(val => {

        this.SendListIdToUpdateGroup(observableBatch);

      });
    }
  }

  btnClick_UpdateGroupProjectSale(id, projcode, Groupproject): Observable<ProjectSaleInfo[]> {
    var auth_token = this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectSaleId'] = id;
      objectjson['ProjectSaleCode'] = projcode;
      objectjson['ProjectGroupMapping'] = Groupproject;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateGroupProjectSaleByGroup", strjsonCusInfo, httpOptions);
    }
  }

  async SendListIdToUpdateGroup(observableBatch: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjsonCusInfo = JSON.stringify(observableBatch);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateGroupProjectSaleByGroup", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          data => {
            console.log('สำเร็จ');
            $('#ModalProjectGroupComplate').modal('show');
            this.currentPageNumber = 1;
            this.LoadProjectSale();
          }
        );
    }
  }
}
